import { Injectable } from '@angular/core';
import { initialize, LDClient, LDUser } from 'launchdarkly-js-client-sdk';

export class LaunchDarklyUser implements LDUser {
    key: string;
    custom?: {
        currentOrganisation: string;
    };

    constructor(key: string, currentOrganisation?: string) {
        this.key = key;
        this.custom = currentOrganisation
            ? {
                  currentOrganisation: currentOrganisation
              }
            : null;
    }
}

// This has been created to allow mocking the LD client for testing purposes
@Injectable({
    providedIn: 'root'
})
export class LaunchDarklyService {
    public getClient(clientId: string, user: LaunchDarklyUser): LDClient {
        return initialize(clientId, user);
    }
}
